"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CoreRenderExecutor {
    constructor(context) {
        this.context = context;
        this.renderState = context.renderState;
    }
    destroy() {
        // Noop
    }
    _reset() {
        this._bindRenderTexture(undefined);
        this._setScissor(undefined);
        this._clearRenderTexture();
    }
    execute() {
        this._reset();
        const quadOps = this.renderState.quadOperations;
        let i = 0;
        const n = quadOps.length;
        while (i < n) {
            this._processQuadOperation(quadOps[i]);
            i++;
        }
    }
    _processQuadOperation(quadOperation) {
        if (quadOperation.renderTextureInfo && quadOperation.renderTextureInfo.ignore) {
            // Ignore quad operations when we are 're-using' another texture as the render texture result.
            return;
        }
        this._setupQuadOperation(quadOperation);
        this._execQuadOperation(quadOperation);
    }
    _setupQuadOperation(quadOperation) {
        // Noop
    }
    _execQuadOperation(op) {
        // Set render texture.
        const renderTexture = op.renderTextureInfo ? op.renderTextureInfo.renderTexture : undefined;
        if (this._renderTexture !== renderTexture) {
            this._bindRenderTexture(renderTexture);
        }
        if (op.renderTextureInfo && !op.renderTextureInfo.cleared) {
            this._setScissor(undefined);
            this._clearRenderTexture();
            op.renderTextureInfo.cleared = true;
            this._setScissor(op.scissor);
        }
        else {
            this._setScissor(op.scissor);
        }
        this._renderQuadOperation(op);
    }
    _renderQuadOperation(op) {
        // Noop
    }
    _bindRenderTexture(renderTexture) {
        this._renderTexture = renderTexture;
    }
    _clearRenderTexture() {
        // Noop
    }
    _setScissor(area) {
        // Noop
    }
}
exports.CoreRenderExecutor = CoreRenderExecutor;
//# sourceMappingURL=CoreRenderExecutor.js.map